import script from "./myLike.vue?vue&type=script&setup=true&lang=js"
export * from "./myLike.vue?vue&type=script&setup=true&lang=js"

import "./myLike.vue?vue&type=style&index=0&id=7decb4e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7decb4e8"]])

export default __exports__